export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;

  const pad = (n, len = 2) => String(n).padStart(len, "0");

  return (
    `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +
    `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}.` +
    `${pad(d.getUTCMilliseconds(), 3)} UTC`
  );
}

export const fmtCurrency = (n, locale="pl-PL", currency="PLN") =>
  typeof n === "number" && !Number.isNaN(n)
    ? new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 2 }).format(n)
    : "—";

export const fmtPercent = (n, locale="pl-PL") =>
  typeof n === "number" ? new Intl.NumberFormat(locale,{style:"percent",maximumFractionDigits:2}).format(n/100) : "—";

export function toNumber(v) {
  if (v === "" || v == null) return 0;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
}
